import config from "@/config"
import http from "@/utils/request"

export default {
	// 打印机设备
	device: {
		index: {
			url: `${config.API_URL}/bwmall/admin/printer/device/index`,
			name: "打印机列表",
			get: async function(params){
				return await http.get(this.url, params);
			}
		},
		save: {
			url: `${config.API_URL}/bwmall/admin/printer/device/save`,
			name: "打印机保存",
			post: async function(data){
				return await http.post(this.url, data);
			}
		},
		del: {
			url: `${config.API_URL}/bwmall/admin/printer/device/del`,
			name: "打印机删除",
			post: async function(data){
				return await http.post(this.url, data);
			}
		},
		status: {
			url: `${config.API_URL}/bwmall/admin/printer/device/status`,
			name: "打印机启停",
			post: async function(data){
				return await http.post(this.url, data);
			}
		},
		test: {
			url: `${config.API_URL}/bwmall/admin/printer/device/test`,
			name: "测试打印",
			post: async function(data){
				return await http.post(this.url, data);
			}
		},
		state: {
			url: `${config.API_URL}/bwmall/admin/printer/device/state`,
			name: "云端状态查询",
			post: async function(data){
				return await http.post(this.url, data);
			}
		}
	},
	// 平台密钥配置
	config: {
		index: {
			url: `${config.API_URL}/bwmall/admin/printer/config/index`,
			name: "密钥配置读取",
			get: async function(){
				return await http.get(this.url);
			}
		},
		save: {
			url: `${config.API_URL}/bwmall/admin/printer/config/save`,
			name: "密钥配置保存",
			post: async function(data){
				return await http.post(this.url, data);
			}
		}
	},
	// 小票模板
	template: {
		index: {
			url: `${config.API_URL}/bwmall/admin/printer/template/index`,
			name: "模板列表",
			get: async function(params){
				return await http.get(this.url, params);
			}
		},
		save: {
			url: `${config.API_URL}/bwmall/admin/printer/template/save`,
			name: "模板保存",
			post: async function(data){
				return await http.post(this.url, data);
			}
		},
		del: {
			url: `${config.API_URL}/bwmall/admin/printer/template/del`,
			name: "模板删除",
			post: async function(data){
				return await http.post(this.url, data);
			}
		},
		setDefault: {
			url: `${config.API_URL}/bwmall/admin/printer/template/setdefault`,
			name: "设为默认模板",
			post: async function(data){
				return await http.post(this.url, data);
			}
		},
		vars: {
			url: `${config.API_URL}/bwmall/admin/printer/template/vars`,
			name: "变量字典",
			get: async function(){
				return await http.get(this.url);
			}
		}
	},
	// 打印记录
	log: {
		index: {
			url: `${config.API_URL}/bwmall/admin/printer/log/index`,
			name: "打印记录列表",
			get: async function(params){
				return await http.get(this.url, params);
			}
		},
		clear: {
			url: `${config.API_URL}/bwmall/admin/printer/log/clear`,
			name: "清空打印记录",
			post: async function(){
				return await http.post(this.url);
			}
		}
	},
	// 手动补打
	orderPrint: {
		url: `${config.API_URL}/bwmall/admin/printer/orderprint`,
		name: "手动补打",
		post: async function(data){
			return await http.post(this.url, data);
		}
	}
}
